import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FC, ReactNode } from 'react';

interface MuiModalProps {
  children: ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  width?: number;
  isVideoModal?: boolean;
  disableClose?: boolean;
}

export const MuiModal: FC<MuiModalProps> = ({
  children,
  open,
  setOpen,
  width,
  isVideoModal,
  disableClose = false,
}) => {
  const handleClose = () => {
    if (!disableClose) {
      setOpen(false);
    }
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    width: isVideoModal ? '100%' : `min(${width || 380}px, calc(100vw - 32px))`,
    maxWidth: isVideoModal ? '100%' : 'calc(100vw - 32px)',
    overflowY: 'auto',
    maxHeight: isVideoModal ? '100%' : 'calc(100vh - 32px)',
    height: isVideoModal ? '100%' : 'auto',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    boxSizing: 'border-box' as const,
    p: { xs: 2, sm: 3 },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {!disableClose && (
          <Box
            sx={{
              position: 'absolute',
              top: '9px',
              right: '6px',
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            <CloseOutlinedIcon onClick={handleClose} sx={{ color: 'black' }} />
          </Box>
        )}
        <Box sx={{ pt: 1 }}>{children}</Box>
      </Box>
    </Modal>
  );
};
